import { render, staticRenderFns } from "./OrthoShoulderPainWake.vue?vue&type=template&id=0b54ed4e&scoped=true"
import script from "./OrthoShoulderPainWake.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderPainWake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54ed4e",
  null
  
)

export default component.exports